import * as React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { GlobalStyled } from '~/src/atomic/obj.globals';
import { GridSettings } from '~/src/atomic/obj.grid';
import { AppRoutes } from '~/src/app/modules/router';
import { FlashMessageProvider } from '~/src/app/components/obj.flash-message';

function App() {
  return (
    <Router>
      <ThemeProvider theme={GridSettings}>
        <FlashMessageProvider>
          <GlobalStyled />
          <AppRoutes />
        </FlashMessageProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
